<template lang="pug">
section.bq-info-section(:class="{ disabled: service_should_be_disabled }")
    .bq-info-row
        .bq-info-label Usage
        .bq-info-value {{ currentService.formattedSpecs.serviceStatus.storage.file }} / {{ currentService.formattedSpecs.currentPlan.storage.file }}
    //- .bq-info-row
    //-     .bq-info-label Storage
    //-     .bq-info-value {{ convertBytesToReadableStorage(currentService.dbDirInfo?.size || 0) }}

//- toolbar
.bq-toolbar(:class="{ disabled: service_should_be_disabled }")
    span.bq-record-count.bq-desktop-only {{ Object.keys(checked).length }} selected
    .bq-toolbar-right
        span.material-symbols-outlined.bq-icon(
            translate="no"
            @click="chatReady && uploadFileInp.click()",
            :class="{ disabled: getFileListFetching || !chatReady }",
            data-track="dbfile_files_icon",
            title="Upload Files"
        ) note_add
        input(
            type="file",
            hidden,
            multiple,
            @change="(e) => dbUploadFiles(e.target.files, () => getFileList())",
            ref="uploadFileInp"
        )
        span.material-symbols-outlined.bq-icon(
            translate="no"
            @click="chatReady && uploadFolderInp.click()",
            :class="{ disabled: getFileListFetching || !chatReady }",
            data-track="dbfile_folder_icon",
            title="Upload Folder"
        ) create_new_folder
        input(
            type="file",
            hidden,
            multiple,
            directory,
            webkitdirectory,
            @change="(e) => dbUploadFiles(e.target.files, () => getFileList())",
            ref="uploadFolderInp"
        )
        span.material-symbols-outlined.bq-icon.bq-desktop-only(
            translate="no"
            @click="downloadChecked",
            :class="{ disabled: getFileListFetching || !Object.keys(checked).length || downloading }",
            data-track="dbfile_download_icon",
            title="Download Selected"
        ) download
        span.material-symbols-outlined.bq-icon.bq-icon--danger(
            translate="no"
            @click="deleteSelected = true",
            :class="{ disabled: getFileListFetching || !Object.keys(checked).length }",
            data-track="dbfile_delete_selected_icon",
            title="Delete Selected"
        ) delete
        template(v-if="chatReady")
            .bq-reindex-wrap(v-if="reindexing" title="Reindexing files for AI...")
                span.material-symbols-outlined.bq-icon.bq-spin(translate="no" style="cursor:default;") sync
                span.bq-reindex-count {{ reindexDone }}/{{ reindexTotal }}
            span.material-symbols-outlined.bq-icon(
                translate="no"
                v-else
                @click="reindexConfirm = true"
                :class="{ disabled: getFileListFetching || !checkedItemCount }"
                title="Reindex selected files for AI"
                data-track="dbfile_reindex_selected"
            ) manage_search

//- file table
.bq-table-wrap.bq-desktop-only(
    ref="tableRef",
    :class="{ 'bq-table-disabled': getFileListFetching, 'bq-uploading': isMyUpload, 'bq-uploading--indeterminate': isMyUpload && !overallUploadProgress }",
    :style="isMyUpload && overallUploadProgress ? { '--upload-progress': overallUploadProgress + '%' } : {}"
)
    //- Upload-status overlay: shown while the file list is (re)loading so the
    //- BunnyLoader (position:absolute z-index:4) doesn't bury the upload row.
    //- Rendered with z-index:5 so it sits above the overlay.
    .bq-upload-loading-status(v-if="(isMyUpload || errorUploadSlots.length) && (getFileListFetching || gateLoading)")
        template(v-for="slot in activeUploadSlots" :key="slot.name")
            span.material-symbols-outlined.bq-upload-icon(translate="no") cloud_upload
            span Uploading: /{{ slot.name }}&nbsp;
                | {{ convertBytesToReadableStorage(Math.floor((slot.fileSize * (slot.progress || 0)) / 100)) }}/{{ convertBytesToReadableStorage(slot.fileSize) }}&nbsp;
            b ({{ uploadCount[0] }}/{{ uploadCount[1] }})
        template(v-for="slot in errorUploadSlots" :key="slot.name + '-err'")
            span.material-symbols-outlined.bq-upload-icon(translate="no") error
            span.bq-upload-error-msg /{{ slot.name }}: {{ slot.error }}
    .bq-empty-drop(
        v-if="chatReady && !isMyUpload && !getFileListFetching && (!listDisplay || listDisplay?.length === 0)"
    )
        span.material-symbols-outlined(translate="no" style="font-size: 3rem") cloud_upload
        p Drop files or folders to index
    BunnyLoader(v-if="getFileListFetching || gateLoading" label="Loading...")
    Table(
        @dragover.stop.prevent="(e) => { if (!chatReady) return; e.dataTransfer.dropEffect = 'copy'; dragHere = true; }",
        @dragleave.stop.prevent="dragHere = false",
        @drop.stop.prevent="(e) => { dragHere = false; if (!chatReady) return; dbOnDrop(e, () => getFileList()); }",
        :class="{ disabled: service_should_be_disabled, dragHere: dragHere }",
        resizable
    )
        template(v-slot:head)
            tr
                th.fixed.bq-sticky-check(style="width: 55px")
                    Checkbox(
                        @click.stop,
                        :modelValue="headerCheckState",
                        @update:modelValue="toggleHeaderCheck",
                        style="display: inline-block",
                        :disabled="!listDisplay || listDisplay.length === 0"
                    )
                    .resizer.fixed
                template(v-for="c in columnList")
                    th.overflow.bq-th-col(v-if="c.value", :class="{ left: c.key === 'name' }", :style="c.key === 'name' ? 'width:320px' : c.key === 'size' ? 'width:160px' : 'width:220px'")
                        span(@click="toggleSort(c.key)")
                            | {{ c.name }}
                            svg.svgIcon(v-if="sortBy === c.key && ascending")
                                use(
                                    xlink:href="/material-icon.svg?v=20250829065753667#icon-arrow-drop-down"
                                )
                            svg.svgIcon(v-if="sortBy === c.key && !ascending")
                                use(
                                    xlink:href="/material-icon.svg?v=20250829065753667#icon-arrow-drop-up"
                                )
                        span.material-symbols-outlined.bq-remove-col(translate="no" @click.stop="removeColumn(c.key)" :class="{ disabled: showTableColumns() <= 1 }" title="Remove column") remove
                        .resizer
                th.fixed.bq-col-toggle-th(style="width:55px;" @mouseenter="showColDropdown" @mouseleave="hideColDropdown" @click.stop="clickColDropdown")
                    span.material-symbols-outlined.bq-icon(translate="no" :class="{ active: colDropdownVisible }" title="Show columns") view_column
                    .bq-col-dropdown(v-show="colDropdownVisible" @click.stop @mouseenter="cancelColHide" @mouseleave="onColDropdownLeave")
                        template(v-for="col in columnList")
                            Checkbox(v-model="col.value", style="display: flex;" :disabled="col.value && showTableColumns() === 1") {{ col.name }}

        template(v-slot:body)
            //- upload status rows (up to 4 concurrent)
            tr.nohover.bq-upload-row(v-for="slot in activeUploadSlots" :key="slot.name")
                td(:colspan="colspan", style="padding: 0")
                    .bq-sticky-info
                        span.material-symbols-outlined.bq-upload-icon(translate="no") cloud_upload
                        | Uploading: /{{ slot.name }} {{ convertBytesToReadableStorage(Math.floor((slot.fileSize * (slot.progress || 0)) / 100)) }}/{{ convertBytesToReadableStorage(slot.fileSize) }}&nbsp;
                        b ({{ uploadCount[0] }}/{{ uploadCount[1] }})

            //- upload error rows
            tr.nohover.bq-upload-row.bq-upload-error-row(v-for="slot in errorUploadSlots" :key="slot.name" @click="dismissErrorSlot(slot)")
                td(:colspan="colspan", style="padding: 0")
                    .bq-sticky-info
                        span.material-symbols-outlined.bq-upload-icon(translate="no") error
                        | &nbsp;/{{ slot.name }} ({{ slot.error }})

            //- gated (no AI platform / no API key): empty placeholder rows (overlay renders on top)
            template(v-if="!chatReady")
                tr.nohover(v-for="i in resultsPerPage")
                    td(:colspan="colspan", style="padding: 0")

            //- loading state: empty rows (bunny overlay renders over the table)
            template(v-else-if="getFileListFetching || !listDisplay")
                tr.nohover(v-for="i in resultsPerPage")
                    td(:colspan="colspan", style="padding: 0")

            //- has data
            template(v-else-if="chatReady")
                //- go up dir row
                tr.nohover.bq-updir-row(
                    v-if="dbCurrentDirectory",
                    :class="{ hoverRow: dbCurrentDirectory }",
                    @click="dbCurrentDirectory = dbCurrentDirectory.split('/').length === 1 ? '' : dbCurrentDirectory.split('/').slice(0, -1).join('/')"
                )
                    td.bq-sticky-check
                        span.material-symbols-outlined.bq-folder-icon.bq-folder-icon--open(translate="no") folder_open
                    td.left(:colspan="colspan - 1")
                        | /{{ dbCurrentDirectory ? dbCurrentDirectory + "/" : "" }}

                tr.hoverRow(
                    v-for="(ns, i) in listDisplay",
                    @click="() => { ns.name[0] === '#' ? setNewDir(ns) : openFile(ns); }",
                    :class="{ 'bq-row-loading': loadingFiles[ns.name] }",
                    :data-track="`dbfile_tb_row`"
                    :data-track-id="ns.name"
                )
                    td.bq-sticky-check(
                        @click.stop="checked[ns?.name] ? delete checked[ns?.name] : (checked[ns?.name] = ns)"
                    )
                        span.material-symbols-outlined.bq-upload-icon.bq-spin(
                            translate="no"
                            v-if="loadingFiles[ns.name]"
                        ) directory_sync
                        Checkbox(
                            v-else,
                            @click.stop,
                            :modelValue="!!checked?.[ns?.name]",
                            @update:modelValue="(value) => { if (value) checked[ns?.name] = ns; else delete checked[ns?.name]; }"
                        )

                    template(v-for="c in columnList")
                        template(v-if="c.value")
                            td.overflow.left(v-if="c.key === 'name' && ns.name[0] == '#'")
                                span.material-symbols-outlined.bq-folder-icon(
                                    translate="no"
                                    style="vertical-align: sub"
                                ) folder
                                | &nbsp;{{ ns.name.slice(1) }}
                            td.overflow.left(v-else-if="c.key === 'name'") {{ ns.name }}
                            td.overflow(v-else-if="c.key === 'size'") {{ convertBytesToReadableStorage(ns.size) }}
                            td.overflow(v-else-if="c.key === 'upl'") {{ new Date(ns.upl).toLocaleString() }}
                    td

                tr.nohover(
                    v-for="i in Math.max(0, resultsPerPage - (listDisplay?.length || 0))"
                )
                    td(:colspan="colspan")

    //- gate loading overlay (rabbit) while we resolve API-key state
    //- .bq-apikey-overlay(v-if="gateLoading")
    //-     .bq-apikey-overlay-inner
    //-         BunnyLoader(:overlay="false" label="Loading...")
    //- AI platform overlay (matches agent.vue's "Select an AI platform" overlay)
    .bq-apikey-overlay(v-if="!gateLoading && !hasAiPlatform")
        .bq-apikey-overlay-inner
            p.bq-apikey-help Select an AI platform.
            .bq-platform-overlay-options
                button.btn.bq-platform-overlay-btn(
                    v-for="p in platformOptions"
                    :key="p.id"
                    type="button"
                    :disabled="savingPlatform"
                    @click="onPlatformSelect(p.id)"
                )
                    img.bq-apikey-logo(v-if="p.logo" :src="p.logo" :alt="p.label" :class="`bq-apikey-logo--${p.id}`")
                    span {{ p.label }}
    //- API key overlay (matches agent.vue's "Enter API Key" overlay)
    .bq-apikey-overlay(v-if="!gateLoading && hasAiPlatform && !hasAiApiKey")
        .bq-apikey-overlay-inner
            img.bq-apikey-logo(v-if="platformLogo" :src="platformLogo" :alt="platformLabel")
            button.btn(type="button" :disabled="savingApiKey || loadingApiKey" :class="{ 'is-loading-key': loadingApiKey }" @click="openApiKeyModal")
                span(v-if="loadingApiKey") {{ apiKeyLoadingDots }}
                span(v-else) Enter API Key
            p.bq-apikey-help
                span.wordset Get your API key:&nbsp;
                a.bq-link(:href="apiKeyDocsUrl" target="_blank" rel="noopener noreferrer") {{ apiKeyDocsUrl }}
    //- drag overlay
    .bq-drag-popup(:class="{ show: dragHere }")
        span.material-symbols-outlined(translate="no" style="font-size: 3rem") cloud_upload
        p Drop files or folders to index

//- pagination
.bq-pagination.bq-desktop-only
    button.bq-page-btn(
        @click="currentPage--",
        :disabled="!chatReady || getFileListFetching || currentPage <= 1",
        data-track="dbfile_prev_page_icon"
    ) &larr; Prev
    button.bq-page-btn(
        @click="currentPage++",
        :disabled="!chatReady || getFileListFetching || (isCurrentDirEndOfList && currentPage >= maxPage)",
        data-track="dbfile_next_page_icon"
    ) Next &rarr;

//- mobile file list (infinite scroll)
//- mobile file list (infinite scroll)
.bq-mobile-list(v-if="isMobile", ref="mobileListRef")
    //- gate loading overlay (rabbit) while we resolve API-key state
    .bq-apikey-overlay(v-if="gateLoading")
        .bq-apikey-overlay-inner
            BunnyLoader(:overlay="false" label="Loading...")
    //- AI platform overlay
    .bq-apikey-overlay(v-else-if="!hasAiPlatform")
        .bq-apikey-overlay-inner
            p.bq-apikey-help Select an AI platform.
            .bq-platform-overlay-options
                button.btn.bq-platform-overlay-btn(
                    v-for="p in platformOptions"
                    :key="p.id"
                    type="button"
                    :disabled="savingPlatform"
                    @click="onPlatformSelect(p.id)"
                )
                    img.bq-apikey-logo(v-if="p.logo" :src="p.logo" :alt="p.label" :class="`bq-apikey-logo--${p.id}`")
                    span {{ p.label }}
    //- API key overlay
    .bq-apikey-overlay(v-else-if="hasAiPlatform && !hasAiApiKey")
        .bq-apikey-overlay-inner
            img.bq-apikey-logo(v-if="platformLogo" :src="platformLogo" :alt="platformLabel")
            button.btn(type="button" :disabled="savingApiKey || loadingApiKey" :class="{ 'is-loading-key': loadingApiKey }" @click="openApiKeyModal")
                span(v-if="loadingApiKey") {{ apiKeyLoadingDots }}
                span(v-else) Enter API Key
            p.bq-apikey-help
                span.wordset Get your API key:&nbsp;
                a.bq-link(:href="apiKeyDocsUrl" target="_blank" rel="noopener noreferrer") {{ apiKeyDocsUrl }}

    //- status banners (show first active slot; count banner covers overall progress)
    .bq-mobile-status(v-if="isMyUpload")
        .bq-mobile-status-icon
            span.material-symbols-outlined(translate="no") cloud_upload
        .bq-mobile-status-text
            .bq-mobile-status-title Uploading
            .bq-mobile-status-detail {{ activeUploadSlots[0]?.name }} ({{ uploadCount[0] }}/{{ uploadCount[1] }})
        .bq-mobile-status-bar
            .bq-mobile-status-bar-fill(
                :class="{ 'bq-mobile-status-bar-fill--indeterminate': !overallUploadProgress }"
                :style="overallUploadProgress ? { width: overallUploadProgress + '%' } : {}"
            )

    .bq-mobile-status.bq-mobile-status--error(v-if="errorUploadSlots.length" @click="dismissErrorSlot(errorUploadSlots[0])")
        .bq-mobile-status-icon
            span.material-symbols-outlined(translate="no") error
        .bq-mobile-status-text
            .bq-mobile-status-detail /{{ errorUploadSlots[0]?.name }}
            .bq-mobile-status-detail ({{ errorUploadSlots[0]?.error }})

    //- loading placeholder
    template(
        v-if="getFileListFetching && (!mobileAllItems || mobileAllItems.length === 0)"
    )
        .bq-mobile-placeholder
            span.bq-loader

    //- file items
    template(
        v-else-if="(mobileAllItems && mobileAllItems.length > 0) || dbCurrentDirectory"
    )
        //- go up dir
        .bq-mobile-file-item(@click="mobileGoUp", v-if="dbCurrentDirectory")
            .bq-mobile-file-icon
                span.material-symbols-outlined.bq-folder-icon.bq-folder-icon--open(translate="no") folder_open
            .bq-mobile-file-info
                .bq-mobile-file-name /{{ dbCurrentDirectory ? dbCurrentDirectory + "/" : "" }}

        //- files and folders
        .bq-mobile-file-item(
            v-for="ns in mobileAllItems",
            :key="ns.name",
            :class="{ 'bq-row-loading': loadingFiles[ns.name] }",
            @click="() => { onMobileTap(ns); }"
        )
            .bq-mobile-file-icon
                span.material-symbols-outlined.bq-upload-icon.bq-spin(
                    translate="no"
                    v-if="loadingFiles[ns.name]"
                ) directory_sync
                span.material-symbols-outlined.bq-folder-icon(
                    translate="no"
                    v-else-if="ns.name[0] === '#'"
                ) folder
                span.material-symbols-outlined.bq-file-icon(translate="no" v-else) description
            .bq-mobile-file-info
                .bq-mobile-file-name {{ ns.name[0] === "#" ? ns.name.slice(1) : ns.name }}
                .bq-mobile-file-size(v-if="ns.name[0] !== '#'") {{ convertBytesToReadableStorage(ns.size) }}
            span.material-symbols-outlined.bq-mobile-file-delete(
                translate="no"
                v-if="ns.name[0] !== '#'",
                @click.stop="checked = { [ns.name]: ns }; deleteSelected = true"
            ) delete
            span.material-symbols-outlined.bq-mobile-file-chevron(
                translate="no"
                v-if="ns.name[0] === '#'"
            ) chevron_right

    //- empty state — tap to upload (only after the first fetch confirms it's empty)
    template(v-else-if="chatReady && !getFileListFetching && hasFetchedOnce")
        .bq-mobile-empty(@click="uploadFileInp.click()")
            span.material-symbols-outlined.bq-mobile-empty-icon(translate="no") note_add
            .bq-mobile-empty-label Tap to upload files

    //- end / loading indicators
    .bq-mobile-end(
        v-if="isCurrentDirEndOfList && !getFileListFetching && mobileAllItems && mobileAllItems.length > 0"
    ) - End of list -
    .bq-mobile-loading(
        v-if="getFileListFetching && mobileAllItems && mobileAllItems.length > 0"
    )
        span.bq-loader

//- modal :: delete selected
Modal(:open="deleteSelected", @close="() => { if (!modalPromise) deleteSelected = false }")
    .bq-modal-delete
        .bq-modal-delete-header
            span.material-symbols-outlined.bq-modal-delete-icon(translate="no") delete
            span Delete Files
        .bq-modal-delete-body
            p Delete {{ Object.keys(checked).length }} file(s) from database storage?
            p.bq-modal-delete-warn This action cannot be undone.
        .bq-modal-delete-footer
            template(v-if="modalPromise")
                span.bq-loader Deleting
            template(v-else)
                button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(
                    @click="deleteSelected = false"
                ) Cancel
                button.bq-modal-delete-btn.bq-modal-delete-btn--delete(
                    @click="deleteFiles",
                    data-track="dbfile_deleteSelModal_delete"
                ) Delete

//- modal :: reindex selected
Modal(:open="reindexConfirm", @close="() => { if (!reindexing) reindexConfirm = false }")
    .bq-modal-delete
        .bq-modal-delete-header
            span.material-symbols-outlined.bq-modal-delete-icon(translate="no") manage_search
            span Reindex Files
        .bq-modal-delete-body
            p Send {{ checkedItemCount }} selected item(s) to the AI agent for re-indexing?
            p.bq-modal-delete-warn Files inside selected folders will also be reindexed.
        .bq-modal-delete-footer
            template(v-if="reindexing")
                span.bq-loader Reindexing {{ reindexDone }}/{{ reindexTotal }}
            template(v-else)
                button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(
                    @click="reindexConfirm = false"
                ) Cancel
                button.bq-modal-delete-btn.bq-modal-delete-btn--delete(
                    @click="reindexAllFiles",
                    data-track="dbfile_reindexSelModal_reindex"
                ) Reindex

//- modal :: enter AI api key
Modal(:open="apiKeyModalOpen" @close="() => { if (!savingApiKey) apiKeyModalOpen = false }")
    .bq-modal-wrap
        .bq-modal-close(@click="apiKeyModalOpen = false" :class="{ disabled: savingApiKey }") &times;
        form.bq-modal-step(@submit.prevent="saveApiKey")
            h2 API Key
            p.bq-modal-desc Enter your {{ platformLabel }} API key.
            textarea.bq-modal-textarea(
                ref="apiKeyInputEl"
                :disabled="savingApiKey || null"
                placeholder="sk-..."
                :value="apiKeyInput"
                rows="3"
                @input="e => apiKeyInput = e.target.value"
            )
            button.btn(
                type="submit"
                :class="{ 'bq-btn--loading': savingApiKey }"
                :disabled="savingApiKey || !apiKeyInput.trim()"
            )
                span.bq-loader(v-if="savingApiKey")
                template(v-else) Save
</template>

<script setup lang="ts">
import { reactive, ref, computed, watch, nextTick, onMounted, onUnmounted } from "vue";
import { SkapiError } from "skapi-js";
import { user } from "@/code/user";
import { currentService, aiApiKeyCache, aiModelCache, agentHistoryRefreshTrigger, serviceClientSecrets, saveAiApiKeyPrivately, loadAiApiKeyPrivately } from "@/views/project-list";
import { convertBytesToReadableStorage } from "@/code/service-spec";
import {
    dbServiceFolders,
    uploadFiles,
    onDrop,
    dbUploadCount as uploadCount,
    dbUploadSlots,
    urlCache,
} from "@/views/service/file";
import { notifyAgentSaveAttachment, bgTaskQueue, type AttachmentSaveInfo } from "@/code/ai_agent";
import mime from "mime";
import Table from "@/components/table.vue";
import Modal from "@/components/modal.vue";
import Pager from "@/code/pager";
import Checkbox from "@/components/checkbox.vue";
import BunnyLoader from "@/components/bunnyLoader.vue";
import { removeFullScreenLoader } from "@/components/jsComponents";
import chatgptLogo from "@/assets/img/logo/ChatGPT-Logo.png";
import claudeLogo from "@/assets/img/logo/claude-ai-symbol.svg";

let dbstore = computed(() => "db:" + currentService.value.id);

// Only treat an upload as belonging to this page when it targets the
// db file store, so a hosting-page upload doesn't display here.
const isMyUpload = computed(() => dbUploadSlots.some(s => !!s.name && !s.error));
const activeUploadSlots = computed(() => dbUploadSlots.filter(s => !!s.name && !s.error));
const errorUploadSlots = computed(() => dbUploadSlots.filter(s => !!s.name && !!s.error));

function dismissErrorSlot(slot: typeof dbUploadSlots[number]) {
    slot.name = '';
    slot.progress = 0;
    slot.fileSize = 0;
    slot.error = undefined;
}
// Overall progress as a percentage of completed files out of total queued.
const overallUploadProgress = computed(() =>
    uploadCount[1] > 0 ? Math.floor((uploadCount[0] / uploadCount[1]) * 100) : 0
);

let loadingFiles: any = reactive({});

let openFile = async (ns: any) => {
    if (loadingFiles[ns.name]) return;

    let filePath = ns.path + "/" + ns.name;
    let cached = urlCache[filePath];

    // reuse cache if it hasn't expired yet (with 60s buffer)
    if (cached && cached.expiresAt > Date.now() + 60000) {
        window.open(cached.url, "_blank");
        return;
    }

    loadingFiles[ns.name] = true;
    try {
        let result = await currentService.value.getTemporaryUrl({
            request: "get-db",
            path: filePath.split("/").slice(1).join("/"), // remove leading '!' if present
            expires: 3600,
        });

        let url = typeof result === "string" ? result : result.url;
        urlCache[filePath] = { url, expiresAt: Date.now() + 3600 * 1000 };
        window.open(url, "_blank");
    } finally {
        delete loadingFiles[ns.name];
    }
};

let downloading = ref(false);

let downloadChecked = async () => {
    if (downloading.value) return;
    let files = Object.keys(checked.value)
        .map((name) => listDisplay.value.find((v: any) => v.name === name))
        .filter((ns: any) => ns && ns.name);
    if (!files.length) return;

    downloading.value = true;
    checked.value = {};

    for (let ns of files as any[]) {
        loadingFiles[ns.name] = true;
    }

    try {
        for (let ns of files as any[]) {
            let filePath = ns.path + "/" + ns.name;
            let cached = urlCache[filePath];
            let url: string;

            if (cached && cached.expiresAt > Date.now() + 60000) {
                url = cached.url;
            } else {
                let isFolder = ns.name[0] === "#";
                let result = await currentService.value.getTemporaryUrl({
                    request: isFolder ? "get-db-zip" : "get-db",
                    path: filePath.split("/").slice(1).join("/"),
                    expires: 3600,
                    contentType: "application/octet-stream",
                });
                url = typeof result === "string" ? result : result.url;
                urlCache[filePath] = { url, expiresAt: Date.now() + 3600 * 1000 };
            }

            delete loadingFiles[ns.name];

            let a = document.createElement("a");
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            // wait between downloads so browser doesn't cancel
            if (files.indexOf(ns) < files.length - 1) {
                await new Promise((r) => window.setTimeout(r, 500));
            }
        }
    } finally {
        for (let ns of files as any[]) {
            delete loadingFiles[ns.name];
        }
        downloading.value = false;
    }
};

let folders: {
    [key: string | "!"]: {
        pager: Pager;
        endOfList: boolean;
    };
} = {}; // cache folders

let dbCurrentDirectory = ref("");

let service_should_be_disabled = computed(() => {
    return (
        currentService.value?.service?.active < 0 ||
        user?.email_verified === false
    );
});

// AI platform + API-key gate (mirrors agent.vue). The file list is only
// fetched/initialized once BOTH a platform is set and a valid API key is
// available for it. Upload UI is gated on the same `chatReady` flag.
type PlatformOption = { id: "claude" | "openai"; label: string; logo: string };
const platformOptions: PlatformOption[] = [
    { id: "claude", label: "Claude", logo: claudeLogo },
    { id: "openai", label: "ChatGPT", logo: chatgptLogo },
];
const savingPlatform = ref(false);
const hasAiApiKey = ref(false);
// True while we're resolving the API-key state for the current platform
// (either at mount, on platform-switch, or after saving a new key). While
// this is true the rest of the overlays stay hidden and a rabbit loader
// renders so we don't flash "Enter API Key" before the cache lookup /
// `listClientSecrets` resolves. Start `true` on mount when a platform is
// already configured so the rabbit shows immediately while we resolve.
const gateLoading = ref(false);
let gateRefreshToken = 0;

const parseAiAgent = (value: string | null | undefined) => {
    const raw = (value || "").trim();
    const [platformRaw] = raw.includes("#") ? raw.split("#") : [raw, ""];
    const platform = platformRaw === "claude" || platformRaw === "openai"
        ? (platformRaw as "claude" | "openai")
        : null;
    return { platform, hasPlatform: !!platform };
};

const hasAiPlatform = computed(() => parseAiAgent(currentService.value?.service?.ai_agent).hasPlatform);
const selectedAiPlatform = computed<"claude" | "openai" | null>(() => parseAiAgent(currentService.value?.service?.ai_agent).platform);

const chatReady = computed(() => hasAiPlatform.value && hasAiApiKey.value);

const platformLabel = computed(() => {
    if (selectedAiPlatform.value === "claude") return "Claude";
    if (selectedAiPlatform.value === "openai") return "ChatGPT";
    return "AI";
});

const platformLogo = computed(() => {
    if (selectedAiPlatform.value === "claude") return claudeLogo;
    if (selectedAiPlatform.value === "openai") return chatgptLogo;
    return "";
});

const apiKeyDocsUrl = computed(() => {
    if (selectedAiPlatform.value === "claude") return "https://platform.claude.com";
    if (selectedAiPlatform.value === "openai") return "https://platform.openai.com/";
    return "";
});

// Resolve whether a usable API key exists for the current platform. Mirrors
// agent.vue's refreshGate() but trimmed to just the key-existence check —
// we don't need chat history / model loading here.
const refreshApiKey = async () => {
    const token = ++gateRefreshToken;
    const platform = selectedAiPlatform.value;
    if (!platform || !currentService.value) {
        hasAiApiKey.value = false;
        gateLoading.value = false;
        return;
    }
    gateLoading.value = true;
    const serviceId = currentService.value.id;

    // 1) lightweight cache
    if (aiApiKeyCache[serviceId]?.[platform]) {
        hasAiApiKey.value = true;
        gateLoading.value = false;
        return;
    }

    // 2) shared client-secrets pager
    const pager = serviceClientSecrets[serviceId];
    if (pager?.list?.[platform]?.client_secret) {
        aiApiKeyCache[serviceId] = {
            ...(aiApiKeyCache[serviceId] || {}),
            [platform]: pager.list[platform].client_secret,
        };
        hasAiApiKey.value = true;
        gateLoading.value = false;
        return;
    }

    // 3) authoritative server lookup
    try {
        const result = await currentService.value.listClientSecrets(false, platform);
        if (token !== gateRefreshToken) return;
        const match = result?.list?.find((s: any) => s.id === platform);
        if (match?.key && typeof match.key === "string" && match.key.trim()) {
            aiApiKeyCache[serviceId] = {
                ...(aiApiKeyCache[serviceId] || {}),
                [platform]: match.key,
            };
            hasAiApiKey.value = true;
        } else {
            hasAiApiKey.value = false;
        }
    } catch (err) {
        if (token === gateRefreshToken) {
            console.error("Failed to look up AI API key", err);
            hasAiApiKey.value = false;
        }
    } finally {
        if (token === gateRefreshToken) gateLoading.value = false;
    }
};

const onPlatformSelect = async (platform: "claude" | "openai") => {
    if (!platform || savingPlatform.value) return;
    savingPlatform.value = true;
    gateLoading.value = true;
    try {
        await currentService.value.setServiceOption({ ai_agent: platform });
        await refreshApiKey();
    } catch (err) {
        console.error("Failed to update AI platform", err);
    } finally {
        savingPlatform.value = false;
    }
};

// API-key modal (mirrors agent.vue saveApiKey: registerClientSecret →
// setServiceOption(ai_agent) → refresh the local key cache, then re-run
// the gate so the upload UI unlocks).
const apiKeyModalOpen = ref(false);
const apiKeyInput = ref("");
const apiKeyInputEl = ref<HTMLTextAreaElement | null>(null);
const savingApiKey = ref(false);
const loadingApiKey = ref(false);
const apiKeyLoadingDots = ref(".");
let apiKeyLoadingDotsTimer: ReturnType<typeof setInterval> | null = null;
const startApiKeyDots = () => {
    if (apiKeyLoadingDotsTimer) return;
    let n = 0;
    apiKeyLoadingDots.value = ".";
    apiKeyLoadingDotsTimer = setInterval(() => {
        n = (n + 1) % 3;
        apiKeyLoadingDots.value = ".".repeat(n + 1);
    }, 350);
};
const stopApiKeyDots = () => {
    if (apiKeyLoadingDotsTimer) {
        clearInterval(apiKeyLoadingDotsTimer);
        apiKeyLoadingDotsTimer = null;
    }
};

const openApiKeyModal = async () => {
    if (!hasAiPlatform.value || savingApiKey.value || loadingApiKey.value) return;
    const platform = selectedAiPlatform.value;
    const serviceId = currentService.value?.id;
    const cachedKey =
        (platform === "claude" || platform === "openai") && serviceId
            ? aiApiKeyCache[serviceId]?.[platform] ||
              serviceClientSecrets[serviceId]?.list?.[platform]?.client_secret ||
              ""
            : "";
    let prefill = cachedKey || "";
    if (!prefill && (platform === "claude" || platform === "openai")) {
        loadingApiKey.value = true;
        startApiKeyDots();
        try {
            prefill = (await loadAiApiKeyPrivately(platform)) || "";
        } finally {
            loadingApiKey.value = false;
            stopApiKeyDots();
        }
    }
    apiKeyInput.value = prefill;
    apiKeyModalOpen.value = true;
    nextTick(() => {
        apiKeyInputEl.value?.focus();
    });
};

const saveApiKey = async () => {
    const platform = selectedAiPlatform.value;
    if (platform !== "claude" && platform !== "openai") return;
    const key = apiKeyInput.value.trim();
    if (!key) return;

    savingApiKey.value = true;
    try {
        const serviceId = currentService.value.id;
        const hadExistingKey = !!(
            aiApiKeyCache[serviceId]?.[platform] ||
            serviceClientSecrets[serviceId]?.list?.[platform]?.client_secret
        );
        await currentService.value.registerClientSecret({
            id: platform,
            key,
            grp: 1,
            req: hadExistingKey ? "update" : "create",
        });
        await currentService.value.setServiceOption({ ai_agent: platform });

        aiApiKeyCache[serviceId] = {
            ...(aiApiKeyCache[serviceId] || {}),
            [platform]: key,
        };

        // Also persist the key as a private record so we can recover the
        // last value on a fresh session without going through the
        // client-secret store.
        void saveAiApiKeyPrivately(serviceId, platform, key);

        const pager = serviceClientSecrets[serviceId];
        if (pager) {
            const mapped = {
                name: platform,
                client_secret: key,
                locked: true,
            };
            if (pager.list?.[platform]) {
                await pager.editItem(mapped);
            } else {
                await pager.insertItems([mapped]);
            }
        }

        apiKeyModalOpen.value = false;
        apiKeyInput.value = "";

        // Drop any stale model cache so the agent page refetches against
        // the new key when it next loads.
        delete aiModelCache[platform];

        await refreshApiKey();
    } catch (err) {
        console.error("Failed to save API key", err);
    } finally {
        savingApiKey.value = false;
    }
};

// fileinputs
let uploadFileInp = ref(null);
let uploadFolderInp = ref(null);

let dragHere = ref(false);
let modalPromise = ref(false);

// column dropdown
let columnList = reactive([
    { name: "Filename", key: "name", value: true },
    { name: "Size", key: "size", value: true },
    { name: "Uploaded", key: "upl", value: true },
]);
let colspan = computed(() => {
    return 2 + columnList.filter((c) => c.value).length; // checkbox + settings
});
const showTableColumns = () => columnList.filter((c) => c.value).length;

const colDropdownVisible = ref(false);
let colHideTimeout: ReturnType<typeof setTimeout> | null = null;
let colClickClosedAt = 0;
const removeColumn = (key: string) => {
    if (showTableColumns() <= 1) return;
    let col = columnList.find((c: any) => c.key === key);
    if (col) col.value = false;
};
const clickColDropdown = () => {
    if (colHideTimeout) { clearTimeout(colHideTimeout); colHideTimeout = null; }
    if (colDropdownVisible.value) {
        colDropdownVisible.value = false;
        colClickClosedAt = Date.now();
    } else {
        colDropdownVisible.value = true;
    }
};
const showColDropdown = () => {
    if (Date.now() - colClickClosedAt < 300) return;
    if (colHideTimeout) { clearTimeout(colHideTimeout); colHideTimeout = null; }
    colDropdownVisible.value = true;
};
const hideColDropdown = () => {
    colHideTimeout = setTimeout(() => { colDropdownVisible.value = false; }, 240);
};
const cancelColHide = () => {
    if (colHideTimeout) { clearTimeout(colHideTimeout); colHideTimeout = null; }
};
const onColDropdownLeave = (e: MouseEvent) => {
    const th = (e.currentTarget as HTMLElement)?.closest('.bq-col-toggle-th');
    if (th && th.contains(e.relatedTarget as Node)) return;
    colHideTimeout = setTimeout(() => { colDropdownVisible.value = false; }, 240);
};

const tableRef = ref<HTMLElement | null>(null);
let columnListInitialized = false;
let prevVisibleColCount = 0;
watch(
    columnList,
    (nv) => {
        let visibleCount = nv.filter((c) => c.value).length;
        if (columnListInitialized && visibleCount > prevVisibleColCount) {
            nextTick(() => {
                let wrap = tableRef.value;
                if (wrap) {
                    let scrollEl = wrap.querySelector('.tableWrap');
                    if (scrollEl) scrollEl.scrollLeft = scrollEl.scrollWidth;
                }
            });
        }
        prevVisibleColCount = visibleCount;
        columnListInitialized = true;
    },
    { immediate: true }
);

let dbUploadOptions = computed(() => ({
    target: "db" as const,
    currentDir: dbCurrentDirectory.value,
    foldersRef: dbServiceFolders,
    storeKey: dbstore.value,
    onItemUploaded: onUploadedCollect,
}));
const ATTACHMENT_NOTIFY_URL_EXPIRES_SECONDS = 60 * 10; // 10m signed URL

// Called by onItemUploaded for each finished file. Gets the CDN temp URL then
// awaits notifyAgentSaveAttachment so the upload slot stays busy until the
// indexing request is submitted. The CSR result is pushed to bgTaskQueue so
// agent.vue can inject Thinking... bubbles right away.
async function onUploadedCollect(info: { file: File; relPath: string; storagePath: string }) {
    const raw = (currentService.value?.service?.ai_agent || "").trim();
    if (!raw) return;
    const [platformRaw, modelRaw] = raw.includes("#") ? raw.split("#") : [raw, ""];
    const platform = (platformRaw === "claude" || platformRaw === "openai")
        ? (platformRaw as "claude" | "openai")
        : null;
    if (!platform) return;

    const serviceId = currentService.value.id;

    try {
        const tu = await currentService.value.getTemporaryUrl({
            request: "get-db",
            path: info.storagePath,
            expires: ATTACHMENT_NOTIFY_URL_EXPIRES_SECONDS,
            generate_temporary_cdn_url: true,
        });
        const url = typeof tu === "string" ? tu : (tu as any)?.url;
        if (!url) return;

        const saveInfo: AttachmentSaveInfo = {
            platform,
            model: modelRaw || undefined,
            service: serviceId,
            owner: currentService.value.owner,
            userId: user?.user_id || undefined,
            serviceName: currentService.value?.service?.name,
            serviceDescription: currentService.value?.service?.description,
            attachment: {
                name: info.file.name,
                storagePath: info.storagePath,
                mime: info.file.type || mime.getType(info.file.name) || undefined,
                size: info.file.size,
                url,
            },
        };

        const result: any = await notifyAgentSaveAttachment(saveInfo);
        if (result?.id && typeof result.id === 'string') {
            bgTaskQueue.push({
                serviceId,
                platform,
                id: result.id,
                filename: info.file.name,
                status: result.status === 'running' ? 'running' : 'pending',
                poll: result.poll ?? undefined,
            });
            agentHistoryRefreshTrigger[serviceId] = (agentHistoryRefreshTrigger[serviceId] || 0) + 1;
        }

    } catch (err) {
        console.error("onUploadedCollect failed", err);
    }
}

const reindexConfirm = ref(false);
const reindexing = ref(false);
const reindexDone = ref(0);
const reindexTotal = ref(0);

// All checked items (files + folders) — used to enable/disable the button.
const checkedItemCount = computed(() =>
    Object.values(checked.value).filter((ns: any) => ns?.name).length
);

// Recursively collect all files under a given directory path.
// dir is in the same format as dbCurrentDirectory (no leading "!").
async function collectFilesInDir(dir: string, results: Array<{ name: string; path: string; size: number }>) {
    let nextPage = false;
    while (true) {
        const result = await currentService.value.listHostDirectory(
            { dir, target: "db" },
            nextPage,
            100
        );
        for (const item of (result.list || [])) {
            if (item.name[0] === '#') {
                const subDir = dir ? `${dir}/${item.name.slice(1)}` : item.name.slice(1);
                await collectFilesInDir(subDir, results);
            } else {
                // Reconstruct the path/name shape the rest of the function expects.
                results.push({ name: item.name, path: `!${dir ? `/${dir}` : ""}`, size: item.size || 0 });
            }
        }
        if (result.endOfList) break;
        nextPage = true;
    }
}

async function reindexAllFiles() {
    if (reindexing.value || !chatReady.value) return;

    const raw = (currentService.value?.service?.ai_agent || "").trim();
    if (!raw) return;

    const [platformRaw, modelRaw] = raw.includes("#") ? raw.split("#") : [raw, ""];
    const platform = (platformRaw === "claude" || platformRaw === "openai")
        ? (platformRaw as "claude" | "openai")
        : null;
    if (!platform) return;

    const checkedItems = Object.values(checked.value) as any[];

    // Seed the list with directly-checked files.
    const filesToIndex: Array<{ name: string; path: string; size: number }> = [];
    for (const ns of checkedItems) {
        if (!ns?.name) continue;
        if (ns.name[0] === '#') {
            // It's a folder — derive the dir path and collect all files inside it.
            const dirPath = (ns.path + "/" + ns.name.slice(1)).split("/").slice(1).join("/");
            await collectFilesInDir(dirPath, filesToIndex);
        } else {
            filesToIndex.push({ name: ns.name, path: ns.path, size: ns.size || 0 });
        }
    }

    if (!filesToIndex.length) return;

    reindexing.value = true;
    reindexDone.value = 0;
    reindexTotal.value = filesToIndex.length;

    const serviceId = currentService.value.id;

    try {
        for (const file of filesToIndex) {
            try {
                const storagePath = (file.path + "/" + file.name).split("/").slice(1).join("/");
                const tu = await currentService.value.getTemporaryUrl({
                    request: "get-db",
                    path: storagePath,
                    expires: 600,
                    generate_temporary_cdn_url: true,
                });
                const url = typeof tu === "string" ? tu : (tu as any)?.url;
                if (!url) { reindexDone.value++; continue; }

                const info: AttachmentSaveInfo = {
                    platform,
                    model: modelRaw || undefined,
                    service: serviceId,
                    owner: currentService.value.owner,
                    serviceName: currentService.value?.service?.name,
                    serviceDescription: currentService.value?.service?.description,
                    attachment: {
                        name: file.name,
                        storagePath,
                        mime: mime.getType(file.name) || undefined,
                        size: file.size,
                        url,
                    },
                };

                const result: any = await notifyAgentSaveAttachment(info);
                if (result?.id && typeof result.id === 'string') {
                    bgTaskQueue.push({
                        serviceId,
                        platform,
                        id: result.id,
                        filename: info.attachment.name,
                        status: result.status === 'running' ? 'running' : 'pending',
                        poll: result.poll ?? undefined,
                    });
                    agentHistoryRefreshTrigger[serviceId] = (agentHistoryRefreshTrigger[serviceId] || 0) + 1;
                }
            } catch (err) {
                console.error("Reindex failed for file", file.name, err);
            }
            reindexDone.value++;
        }
    } finally {
        reindexing.value = false;
        reindexConfirm.value = false;
    }
}

let dbUploadFiles = (
    files: FileList | File[],
    callback?: (hasOverwritten: boolean) => void
) => {
    uploadFiles(
        files as File[],
        callback,
        undefined,
        dbUploadOptions.value
    );
};

let dbOnDrop = (e: any, callback?: (hasOverwritten: boolean) => void) => {
    onDrop(e, callback, dbUploadOptions.value);
};

const resultsPerPage = 12;
let listDisplay = ref([]);
let sortBy = ref("name");
let ascending = ref(true);
let currentPage = ref(1);
let endOfList: any = reactive({});
let maxPage = ref(0);
let getFileListFetching = ref(true); // init value should be true
let hasFetchedOnce = ref(false); // true after the first directory fetch completes

let isDirEndOfList = (dir: string) => {
    return !!(folders?.[dir]?.endOfList ?? endOfList[dir]);
};

let isCurrentDirEndOfList = computed(() => {
    return isDirEndOfList(dbCurrentDirectory.value || "!");
});

// checks
let checked: any = ref({});
let headerCheckState = computed(() => {
    if (!listDisplay.value || listDisplay.value.length === 0) return false;
    let allPageChecked = listDisplay.value.every(
        (d: any) => checked.value[d.name]
    );
    if (allPageChecked) return true;
    let someChecked = Object.keys(checked.value).length > 0;
    if (someChecked) return null;
    return false;
});

const toggleHeaderCheck = () => {
    if (headerCheckState.value === true) {
        checked.value = {};
    } else {
        if (listDisplay.value?.length) {
            listDisplay.value.forEach((d: any) => (checked.value[d.name] = d));
        }
    }
};

let deleteSelected = ref(false);

let deleteFiles = async () => {
    modalPromise.value = true;
    let toDel = Object.values(checked.value).filter(
        (v: any) =>
            !!v &&
            typeof v.name === "string" &&
            v.name.length > 0 &&
            typeof v.path === "string"
    ) as any[];

    try {
        let currDir = dbCurrentDirectory.value || "!";
        let pager = folders[currDir]?.pager;

        await currentService.value.deleteHostFiles({
            target: "db",
            paths: toDel.map(
                (v) =>
                    v.path +
                    "/" +
                    (() => {
                        let n = v.name as string;
                        if (n.startsWith("#")) {
                            return n.slice(1) + "/";
                        }
                        return n;
                    })()
            ),
        });

        for (let v of toDel) {
            if (pager) {
                await pager.deleteItem(v.name);
            }
        }

        getFileList().then(() => {
            // when empty, go back a page
            if (!listDisplay.value.length && currentPage.value > 1) {
                currentPage.value--;
            }
        });

        deleteSelected.value = false;
        checked.value = {};
    } catch (err: any) {
        if (err instanceof SkapiError) {
            alert(err.message);
        } else {
            throw err;
        }
    } finally {
        modalPromise.value = false;
    }
};

let restoreCachedFolders = () => {
    let key = dbstore.value;

    if (dbServiceFolders?.[key] && Object.keys(dbServiceFolders[key]).length) {
        folders = dbServiceFolders[key];
    } else {
        dbServiceFolders[key] = folders;
    }
};

restoreCachedFolders();

const initDbFileList = () => {
    getFileListFetching.value = true;
    currentService.value.getDirInfo({ target: "db" });
};

// Resolve API-key state up front so the overlays show the right step.
if (hasAiPlatform.value) {
    void refreshApiKey();
} else {
    hasAiApiKey.value = false;
}

if (chatReady.value) {
    initDbFileList();
} else {
    // Don't fetch anything until the user picks an AI platform and has a key.
    getFileListFetching.value = false;
}
removeFullScreenLoader();

watch(
    () => currentService.value.dbDirInfo.path,
    (path) => {
        if (!chatReady.value) return;
        if (path) {
            getFileList("conditional").then(() => {
                getFileListFetching.value = false;
                hasFetchedOnce.value = true;
            });
        }
    },
    {
        immediate: true,
    }
);

// When platform + API key are first both present, kick off the initial
// directory + file-list fetch that we skipped at mount time.
watch(chatReady, (now, prev) => {
    if (now && !prev) {
        initDbFileList();
    }
});

// React to external `ai_agent` changes (e.g. user changed platform on the
// agent page): re-resolve the API-key state for the new platform.
watch(
    () => currentService.value?.service?.ai_agent,
    () => {
        if (hasAiPlatform.value) {
            void refreshApiKey();
        } else {
            hasAiApiKey.value = false;
            gateLoading.value = false;
        }
    }
);

// When an EXCEED_LIMIT upload error appears, refresh the service so the
// usage display reflects the current storage consumption.
watch(errorUploadSlots, (slots) => {
    if (!slots.length || !currentService.value) return;
    currentService.value.refresh().catch(() => {});
}, { deep: false });

let setNewDir = (ns: any) => {
    if (!ns?.path || !ns?.name) {
        return dbCurrentDirectory;
    }

    let path = ns.path;
    path = path.split("/");
    if (path.length > 1) {
        dbCurrentDirectory.value =
            path.slice(1).join("/") + "/" + ns.name.slice(1);
    } else {
        dbCurrentDirectory.value = ns.name.slice(1);
    }

    return dbCurrentDirectory;
};

watch(dbCurrentDirectory, () => {
    checked.value = {};
    getFileList();
});

async function getFileList(refresh: string | boolean = false) {
    if (!refresh && getFileListFetching.value) return;

    getFileListFetching.value = true;

    let currDir = dbCurrentDirectory.value || "!";
    let hasPage = folders?.[currDir]?.pager;

    let pager = null;

    if (hasPage) {
        pager = folders[currDir].pager;
        if (typeof folders[currDir].endOfList !== "boolean") {
            folders[currDir].endOfList = !!endOfList[currDir];
        }
        endOfList[currDir] = folders[currDir].endOfList;
        maxPage.value = Math.ceil(pager.map.length / pager.resultsPerPage);
    }

    if (!hasPage || (refresh && refresh !== "conditional")) {
        folders[currDir] = {
            pager: await Pager.init({
                id: "name",
                sortBy: sortBy.value,
                order: ascending.value ? "asc" : "desc",
                resultsPerPage,
            }),
            endOfList: false,
        };
        maxPage.value = 0;
        currentPage.value = 1;
        endOfList[currDir] = false;
    }

    pager = folders[currDir].pager;

    if (refresh && refresh !== "conditional") {
        checked.value = {};
    }

    if (
        (refresh && refresh !== "conditional") ||
        (!isDirEndOfList(currDir) && currentPage.value > maxPage.value)
    ) {
        try {
            let l = await currentService.value.listHostDirectory(
                { dir: dbCurrentDirectory.value, target: "db" },
                !(refresh || maxPage.value == 0),
                resultsPerPage * 4
            );
            if (l.list.length > 0) {
                await pager.insertItems(l.list);
                let fl = pager.getPage(currentPage.value);
                listDisplay.value = fl.list;
                maxPage.value = fl.maxPage;
                endOfList[currDir] = l.endOfList;
                folders[currDir].endOfList = l.endOfList;
            } else {
                listDisplay.value = [];
                endOfList[currDir] = true;
                folders[currDir].endOfList = true;
            }
        } finally {
            getFileListFetching.value = false;
        }
    } else if (
        isDirEndOfList(currDir) ||
        (maxPage.value && currentPage.value <= maxPage.value)
    ) {
        let fl = pager.getPage(currentPage.value);
        listDisplay.value = fl.list;
        maxPage.value = fl.maxPage;
        getFileListFetching.value = false;
    }
}

let resetIndex = async () => {
    let currDir = dbCurrentDirectory.value || "!";
    await folders[currDir].pager.resetIndex({
        sortBy: sortBy.value,
        order: ascending.value ? "asc" : "desc",
    });
    if (currentPage.value !== 1) {
        currentPage.value = 1;
    } else {
        getFileList();
    }
};

let toggleSort = (search: any) => {
    if (getFileListFetching.value || !listDisplay.value.length) {
        return;
    }

    if (sortBy.value === search) {
        ascending.value = !ascending.value;
    } else {
        sortBy.value = search;
    }
};

// call getPage when currentPage changes
watch(currentPage, (n, o) => {
    if (
        n !== o &&
        n > 0 &&
        (n <= maxPage.value ||
            (n > maxPage.value &&
                !isDirEndOfList(dbCurrentDirectory.value || "!")))
    ) {
        getFileList();
    } else {
        currentPage.value = o;
    }
});

// initialize the pager when sort changes
watch([sortBy, ascending], () => {
    if (!getFileListFetching.value) {
        let currDir = dbCurrentDirectory.value || "!";
        if (isDirEndOfList(currDir)) {
            resetIndex();
        } else {
            getFileList(true);
        }
    }
});

// mobile infinite scroll
const isMobile = ref(false);
const mobileListRef = ref<HTMLElement | null>(null);

const checkMobileResize = () => {
    isMobile.value = window.innerWidth <= 768;
};

const mobileAllItems = computed(() => {
    let _ = listDisplay.value;
    let mp = maxPage.value;
    let currDir = dbCurrentDirectory.value || "!";
    if (!isMobile.value || !folders?.[currDir]?.pager || mp <= 0) return [];
    let pager = folders[currDir].pager;
    let allItems: any[] = [];
    for (let i = 1; i <= mp; i++) {
        let page = pager.getPage(i);
        allItems.push(...page.list);
    }
    return allItems;
});

let mobileScrollTicking = false;
const onMobileScroll = () => {
    if (!isMobile.value || !mobileListRef.value || getFileListFetching.value)
        return;
    if (mobileScrollTicking) return;
    mobileScrollTicking = true;
    requestAnimationFrame(() => {
        mobileScrollTicking = false;
        if (!mobileListRef.value) return;

        let rect = mobileListRef.value.getBoundingClientRect();
        let listBottom = rect.top + mobileListRef.value.offsetHeight;

        if (
            listBottom - window.innerHeight < 300 &&
            !isDirEndOfList(dbCurrentDirectory.value || "!") &&
            !getFileListFetching.value
        ) {
            let fetchPage = maxPage.value + 1;
            if (fetchPage !== currentPage.value) {
                currentPage.value = fetchPage;
            }
        }
    });
};

const onMobileTap = (ns: any) => {
    if (ns.name[0] === "#") {
        setNewDir(ns);
    } else {
        openFile(ns);
    }
};

const mobileGoUp = () => {
    dbCurrentDirectory.value =
        dbCurrentDirectory.value.split("/").length === 1
            ? ""
            : dbCurrentDirectory.value.split("/").slice(0, -1).join("/");
};

onMounted(() => {
    checkMobileResize();
    window.addEventListener("resize", checkMobileResize);
    window.addEventListener("scroll", onMobileScroll, { passive: true });
});

onUnmounted(() => {
    window.removeEventListener("resize", checkMobileResize);
    window.removeEventListener("scroll", onMobileScroll);
});
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

/* ─── API key modal scoped overrides (mirrors agent.vue / service.vue) ─── */
.bq-modal-wrap {
    .bq-modal-textarea {
        width: 100%;
        padding: 0.75rem 1rem;
        border: 1px solid @line;
        background: @paper;
        color: @ink;
        font-family: @mono;
        font-size: 0.9rem;
        outline: none;
        margin-bottom: 0.75rem;
        border-radius: 0;
        transition: border-color 0.15s;
        resize: vertical;
        min-height: 4rem;
        word-wrap: break-word;
        overflow-x: hidden;
        white-space: pre-wrap;

        &::placeholder { color: @placeholder; }
        &:focus { border-color: @ink; }
        &:disabled { opacity: 0.5; cursor: default; }
    }

    .btn {
        width: 100%;
        align-self: stretch;
        min-width: 0;
        height: auto;
    }
}

/* ─── info section ─── */
.bq-info-section {
    display: flex;
    flex-direction: column;
    gap: 0;
    border: 1px solid @line;
    font-family: @mono;

    &.disabled {
        opacity: 0.4;
        pointer-events: none;
    }
}

.bq-info-row {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid @line;

    &:last-child {
        border-bottom: none;
    }
}

.bq-info-label {
    font-size: 0.78rem;
    color: @muted;
    min-width: 5rem;
    flex-shrink: 0;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.bq-info-value {
    flex: 1;
    font-size: 0.85rem;
    color: @ink;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ─── icon shared ─── */
.bq-icon {
    font-size: 1.4rem;
    color: @muted;
    transition: color 0.15s;
    user-select: none;
    vertical-align: middle;
    cursor: pointer;

    &:hover,
    &.active {
        color: @pink;
    }

    &.disabled {
        opacity: 0.3;
        pointer-events: none;
        cursor: default;
    }

    &.bq-icon--danger {
        &:hover {
            color: @danger;
        }
    }
}

/* ─── toolbar ─── */
.bq-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    margin: 0.75rem 0 0;
    padding: 0.5rem 0;

    &.disabled {
        opacity: 0.4;
        pointer-events: none;
    }
}

.bq-toolbar-right {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-left: auto;
    flex-shrink: 0;
}

.bq-record-count {
    font-size: 0.75rem;
    color: @muted;
    letter-spacing: 0.02em;
}

.bq-reindex-wrap {
    display: flex;
    align-items: center;
    gap: 0.25rem;

    .bq-icon:hover {
        color: @muted;
    }
}

.bq-reindex-count {
    font-size: 0.75rem;
    color: @muted;
    letter-spacing: 0.02em;
    white-space: nowrap;
}

/* ─── file table ─── */
.bq-empty-drop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: @muted;
    font-family: @mono;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    user-select: none;
    pointer-events: none;
    z-index: 2;

    p {
        margin: 0;
    }
}

:deep(.tableWrap) {
    border: 1px solid @line;
}

:deep(.tableMsg) {
    color: @muted;
}

:deep(.customTbl) {
    background: @paper;

    thead {
        tr {
            &::before,
            &::after {
                display: none;
            }
        }

        th {
            padding: 0.75rem 1rem;
        }
    }

    tbody {
        tr {
            &::before,
            &::after {
                display: none;
            }

            &:hover td {
                border: none;
            }
        }

        td {
            padding: 0 1rem;
            height: 3rem;
            max-height: 3rem;
            box-sizing: border-box;
            overflow: hidden;
            vertical-align: middle;
        }
    }

    .nohover:hover {
        &::before,
        &::after {
            display: none;
        }
    }
}

:deep(._checkbox) {
    padding: 0 !important;
    color: @ink;

    svg {
        width: 20px;
        height: 20px;
    }
}

:deep(.svgIcon) {
    fill: @muted;
    width: 18px;
    height: 18px;
    vertical-align: middle;
}

.bq-folder-icon {
    font-size: 1.25rem;
    color: @muted;
    vertical-align: sub;
    font-variation-settings: "FILL" 1;

    &--open {
        font-variation-settings: "FILL" 0;
    }
}

/* ─── column dropdown ─── */
.bq-th-col {
    position: relative;

    .bq-remove-col {
        position: absolute;
        right: 14px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 1.1rem;
        color: @muted;
        cursor: pointer;
        opacity: 0;
        transition: opacity 0.15s, color 0.15s;
        user-select: none;
        z-index: 1;

        &:hover {
            color: @danger;
        }

        &.disabled {
            opacity: 0.2;
            pointer-events: none;
        }
    }

    &:hover .bq-remove-col {
        opacity: 1;
    }
}

.bq-col-toggle-th {
    position: relative;
    text-align: center;
    cursor: pointer;
    vertical-align: middle;

    .bq-icon {
        font-size: 1.2rem;
    }

    .bq-col-dropdown {
        position: absolute;
        top: calc(100% - 0.5rem);
        right: 0.5rem;
        background: @paper;
        border: 1px solid @muted;
        z-index: 1000;
        padding: 0.2rem;
        box-shadow: 2px 2px 0 rgba(0, 0, 0, 0.15);

        :deep(._checkbox) {
            padding: 0.5rem !important;
            font-size: 0.75rem;
            white-space: nowrap;
            cursor: pointer;
            color: @ink;

            > div {
                font-size: 0.75rem;
            }

            &:hover {
                background: @hover-bg;
            }

            svg {
                width: 16px;
                height: 16px;
                vertical-align: middle;
            }
        }
    }
}

:deep(tr.nohover.hoverRow) {
    &:hover {
        cursor: pointer !important;
        background: @hover-bg !important;
    }
}

:deep(tr.bq-row-loading) {
    opacity: 0.6;
    pointer-events: none;
}

.bq-mobile-file-item.bq-row-loading {
    opacity: 0.6;
    pointer-events: none;
}

.bq-upload-icon {
    font-size: 1.25rem;
    color: @muted;
    margin-right: 0.5rem;
    vertical-align: middle;
}

.bq-spin {
    animation: bq-spin 1.5s linear infinite;
}

@keyframes bq-spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

/* ─── pagination ─── */
.bq-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.75rem 8px;
}

.bq-page-btn {
    display: inline-flex;
    align-items: center;
    padding: 0.45rem 0.8rem;
    border: 1px solid @line;
    background: @paper;
    color: @ink;
    font-family: @mono;
    font-size: 0.8rem;
    cursor: pointer;
    transition: border-color 0.15s;
    border-radius: 0;
    box-shadow: 2px 2px rgba(0, 0, 0, 0.12);

    &:hover:not(:disabled) {
        border-color: @ink;
    }

    &:disabled {
        opacity: 0.3;
        cursor: default;
        pointer-events: none;
    }

    &::after {
        display: none;
    }
}

/* ─── AI platform overlay (mirrors agent.vue) ─── */
.bq-apikey-overlay {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    // Sit below the table's sticky header. Header padding (0.75rem * 2) +
    // content ≈ ~3rem; keep in sync with `:deep(.customTbl) thead th` padding.
    top: 3rem;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: fade(@paper-lit, 85%);
    padding: 1rem;
}

.bq-apikey-overlay-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.85rem;
    text-align: center;
    max-width: 32rem;

    .btn {
        align-self: center;
        min-width: 11rem;
    }

    // Keep the button in its normal active styling while we're fetching the
    // previous API key — disabled fades it out and on mobile the lingering
    // :hover state flips it to white, which makes the dots animation invisible.
    .btn.is-loading-key,
    .btn.is-loading-key:hover,
    .btn.is-loading-key:disabled,
    .btn.is-loading-key:focus,
    .btn.is-loading-key:active {
        opacity: 1;
        background: @ink;
        color: @paper;
        cursor: progress;
    }
}

.bq-apikey-logo {
    width: 3rem;
    height: 3rem;
    object-fit: contain;
}

.bq-apikey-help {
    margin: 0;
    color: @muted;
    font-size: 0.83rem;
    line-height: 1.4;
}

.bq-platform-overlay-options {
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
    justify-content: center;
}

.bq-platform-overlay-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 9rem;

    .bq-apikey-logo {
        width: 1.25rem;
        height: 1.25rem;
    }
}

.bq-link {
    color: @pink;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

/* ─── drag popup ─── */
.bq-drag-popup {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background: fade(@paper-lit, 85%);
    border: 2px dashed @pink;
    color: @pink;
    font-family: @mono;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    user-select: none;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s;
    z-index: 10;

    &.show {
        opacity: 1;
    }

    p {
        margin: 0;
    }
}

.bq-table-disabled {
    pointer-events: none;

    :deep(thead) {
        opacity: 0.5;
    }
}

.bq-upload-loading-status {
    position: relative;
    z-index: 5;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.4rem 0.75rem;
    font-size: 0.85rem;
    background: var(--bq-surface, #fff);
    border-bottom: 1px solid @line;
}

.bq-table-wrap {
    position: relative;
    overflow: hidden;
    margin-top: 0.25rem;

    &.bq-uploading::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 3px;
        width: var(--upload-progress, 0%);
        background: @pink;
        z-index: 10;
        pointer-events: none;
        transition: width 0.3s ease;
    }

    &.bq-uploading--indeterminate::before {
        width: 30%;
        transition: none;
        animation: bq-indeterminate 1.8s ease-in-out infinite;
    }
}

:deep(.bq-upload-row),
:deep(.bq-status-row),
:deep(tr:has(> td > .bq-sticky-info)) {
    td {
        overflow: visible !important;
        background: transparent;
    }
}

:deep(.bq-upload-error-row) {
    td { background: transparent; }

    .bq-sticky-info {
        color: @danger;
        cursor: pointer;

        .bq-upload-icon {
            color: @danger;
        }
    }
}

.bq-upload-error-msg {
    color: @danger;
}

.bq-mobile-status--error {
    align-items: flex-start;
    .bq-mobile-status-icon span { color: @danger; }
    .bq-mobile-status-title { color: @danger; }
    .bq-mobile-status-detail { color: @danger; }
}

:deep(.bq-sticky-info) {
    position: sticky;
    left: 0;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    padding: 0 1rem;
}

/* ─── sticky checkbox column ─── */
:deep(.bq-sticky-check) {
    position: sticky;
    left: 0;
    z-index: 2;
    background: @paper;

    &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 1px;
        background: @line;
    }
}

@keyframes bq-indeterminate {
    0% {
        left: -30%;
    }
    100% {
        left: 100%;
    }
}

/* ─── mobile ─── */
.bq-mobile-list {
    display: none;
}

.bq-mobile-status {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 0;
    border-bottom: 1px solid @line;
    font-size: 0.85rem;
    color: @muted;
    position: relative;
}

.bq-mobile-status-icon {
    flex-shrink: 0;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0.1rem;

    .material-symbols-outlined {
        font-size: 1.25rem;
    }
}

.bq-mobile-status-text {
    flex: 1;
    min-width: 0;
}

.bq-mobile-status-title {
    font-size: 0.85rem;
    color: @ink;
}

.bq-mobile-status-detail {
    font-size: 0.78rem;
    color: @muted;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 0.1rem;
}

.bq-mobile-status-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: @line;
    overflow: hidden;
}

.bq-mobile-status-bar-fill {
    height: 100%;
    background: @pink;
    transition: width 0.3s ease;

    &--indeterminate {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 30%;
        transition: none;
        animation: bq-indeterminate 1.8s ease-in-out infinite;
    }
}

.bq-mobile-file-item {
    display: flex;
    align-items: center;
    padding: 0.75rem 0;
    border-bottom: 1px solid @line;
    cursor: pointer;
    min-height: 62px;
    box-sizing: border-box;

    &:active {
        background: @hover-bg;
    }
}

.bq-mobile-file-icon {
    flex-shrink: 0;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.75rem;
}

.bq-mobile-file-info {
    flex: 1;
    min-width: 0;
}

.bq-mobile-file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.9rem;
}

.bq-mobile-file-size {
    font-size: 0.78rem;
    color: @muted;
    margin-top: 0.15rem;
}

.bq-mobile-file-delete {
    flex-shrink: 0;
    font-size: 1.2rem !important;
    color: @muted;
    margin-left: 0.5rem;
    cursor: pointer;

    &:active {
        color: @danger;
    }
}

.bq-mobile-file-chevron {
    flex-shrink: 0;
    font-size: 1.2rem !important;
    color: @muted;
    margin-left: 0.5rem;
}

.bq-file-icon {
    color: @muted;
}

.bq-mobile-placeholder,
.bq-mobile-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    color: @muted;
}

.bq-mobile-end {
    text-align: center;
    padding: 1.5rem;
    font-size: 0.82rem;
    color: @muted;
}

.bq-mobile-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    text-align: center;
    padding: 3rem 1rem;
    color: @muted;
    font-size: 0.9rem;
    cursor: pointer;
    user-select: none;
    transition: color 0.15s;

    &:hover {
        color: @ink;
    }
}

.bq-mobile-empty-icon {
    font-size: 4rem;
    color: @pink;
}

.bq-mobile-empty-label {
    font-family: @mono;
}

@media (max-width: 768px) {
    :deep(.bq-sticky-check) {
        display: none;
    }

    [data-track="dbfile_delete_selected_icon"],
    [data-track="dbfile_folder_icon"] {
        display: none;
    }

    .bq-desktop-only {
        display: none !important;
    }

    .bq-mobile-list {
        display: block;
        position: relative;
        min-height: 12rem;
    }

    // On mobile the overlay covers the entire mobile list (no sticky header
    // to clear) — match agent.vue's overlay exactly.
    .bq-apikey-overlay {
        top: 0;
        background: fade(@paper-lit, 85%);
    }

    // Match agent.vue mobile: overlay buttons span full width.
    .bq-apikey-overlay-inner .btn,
    .bq-platform-overlay-btn {
        width: 100%;
    }
}
</style>
